import { Button as BaseButton, ButtonProps, forwardRef, useTheme } from '@chakra-ui/react';
import { isCorporateThemeSelector } from 'modules/app/appSlice';
import { rgba } from 'polished';
import { MouseEvent, KeyboardEvent, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { getTypes, hasType } from 'utils/account-type';

const Button = forwardRef<ButtonProps, 'button'>(({ children, ...props }, ref) => {
  const [isActive, setIsActive] = useState(false);
  const { colors } = useTheme();
  const isCorporateTheme = useSelector(isCorporateThemeSelector);
  const context = useSelector((state: RootState) => state.app.context);
  const { accounts } = useSelector((state: RootState) => state.user);
  const isGuestMyChooose = hasType(getTypes(accounts), ['GuestMyChooose']);
  const isRippleEffectApplied = isCorporateTheme && context !== 'mychooose' && !isGuestMyChooose;

  const handleClick = (e: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>) => {
    if (isRippleEffectApplied) {
      setIsActive(true);
      setTimeout(() => setIsActive(false), 2000);
    }
    //@ts-ignore
    props.onClick && props.onClick(e);
  };

  const getRippleColor = () => {
    if (!isRippleEffectApplied || ['ghost', 'ghostWithHover', 'dashed', 'link'].includes(props.variant ?? '')) {
      return colors.white;
    }
    return colors.buttons?.primary ?? colors.other.cta;
  };

  return (
    <BaseButton
      ref={ref}
      height={(props.height || props.h) ?? '50px'}
      borderRadius="35px"
      colorScheme="primary"
      fontWeight={600}
      {...props}
      onMouseDown={e => isCorporateTheme && e.preventDefault()}
      onClick={handleClick}
      onKeyUp={e => (e.key === 'Enter' || e.key === ' ') && handleClick(e)}
      sx={{
        '@keyframes ripple': {
          '0%': {
            boxShadow: `0 0 0 0 ${rgba(getRippleColor(), 0.2)}`,
          },
          '70%': {
            boxShadow: `0 0 0 15px ${rgba(getRippleColor(), 0)}`,
          },
          '100%': {
            boxShadow: `0 0 0 0 ${rgba(getRippleColor(), 0)}`,
          },
        },
        animation: isActive ? 'ripple 1.5s 1' : 'none',
        ...props.sx,
      }}
    >
      {children}
    </BaseButton>
  );
});

export default Button;
